import { render, staticRenderFns } from "./AccumulationSettingIframe.vue?vue&type=template&id=6ece07c6&"
import script from "./AccumulationSettingIframe.vue?vue&type=script&lang=ts&"
export * from "./AccumulationSettingIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports